import ScandphotosOrdersApi from '../ScandphotosOrdersApi';
import * as types from './ScandphotosActionTypes';

function newOrderSuccess(newOrder: any) {
    return { type: types.SCANDPHOTOS_NEW_ORDER_SUCCESS, result: newOrder };
}

export function newOrder(
    pendingOrderId?: string,
    orderCollectionId?: number,
    newPendingOrder?: boolean
) {
    return (dispatch: (result: any) => void) =>
        ScandphotosOrdersApi.newOrder(pendingOrderId, orderCollectionId, newPendingOrder).then(
            (result: any) => {
                dispatch(newOrderSuccess(result));
            }
        );
}

function getFirmDetailsSuccess(details: any) {
    return {
        type: types.SCANDPHOTOS_NEW_ORDER_FIRM_DETAILS_SUCCESS,
        result: details
    };
}

export function getFirmDetails(firmId: number) {
    return (dispatch: (result: any) => void) =>
        ScandphotosOrdersApi.firmDetails(firmId).then((result: any) => {
            dispatch(getFirmDetailsSuccess(result));
        });
}

function createOrderSuccess(order: any) {
    return { type: types.SCANDPHOTOS_CREATE_ORDER_SUCCESS, result: order };
}

export function createOrder(orderInfo: any, calendarItem: any, orderCollectionId?: number) {
    return (dispatch: (result: any) => void) =>
        ScandphotosOrdersApi.createOrder(orderInfo, calendarItem, orderCollectionId).then(
            (result: any) => {
                dispatch(createOrderSuccess(result));
            }
        );
}

function getOrdersSuccess(orders: any) {
    return { type: types.SCANDPHOTOS_GET_ORDERS_SUCCESS, result: orders };
}

export function getOrders() {
    return (dispatch: (result: any) => void) =>
        ScandphotosOrdersApi.getOrders().then((result: any) => {
            dispatch(getOrdersSuccess(result));
        });
}
